import movieStatusUtilsFactory from 'utils/cms/v2/movieStatus';

export const { getMovieStatus, getAllMovieStatuses } = movieStatusUtilsFactory();